import React from "react";
import Marquee from "react-fast-marquee";

interface MarqueeDisplayProps {
  messages: string[];
  speed?: number; // default 50 (higher = faster)
  fontSize?: number;
  textColor?: string;
  backgroundColor?: string;
  gap?: number; // gap between messages (px)
  pauseOnHover?: boolean;
}

const MarqueeDisplay: React.FC<MarqueeDisplayProps> = ({
  messages,
  speed = 100,
  fontSize = 24,
  textColor = "#FFD233",
  backgroundColor = "#FFFFFF10",
  gap = 100,
  pauseOnHover = false,
}) => {
  return (
    <div
      style={{
        backgroundColor,
        color: textColor,
        fontSize: `${fontSize}px`,
        width: "100%",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        paddingTop: "20px",
        paddingBottom: "20px",
      }}
    >
      <Marquee
        gradient={false} // disables the fade effect
        speed={speed}
        pauseOnHover={pauseOnHover}
        direction="left"
        loop={0} // infinite loop
      >
        {messages.map((msg, index) => (
          <span
            key={index}
            style={{
              marginRight: `${gap}px`,
              whiteSpace: "nowrap",
              fontWeight: 500,
            }}
          >
            {msg}
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default MarqueeDisplay;
